import React, { useEffect, useState } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';

const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const HR = () => {
  const [activeTab, setActiveTab] = useState('today');
  const [employees, setEmployees] = useState([]);
  const [todayAttendance, setTodayAttendance] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(false);

  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(now.getFullYear());

  const [showAddEmployee, setShowAddEmployee] = useState(false);
  const [editEmployee, setEditEmployee] = useState(null);
  const [empName, setEmpName] = useState('');
  const [empNic, setEmpNic] = useState('');
  const [empPhone, setEmpPhone] = useState('');
  const [empRole, setEmpRole] = useState('');
  const [empType, setEmpType] = useState('permanent');
  const [empSalary, setEmpSalary] = useState('');
  const [empWage, setEmpWage] = useState('');
  const [empJoinDate, setEmpJoinDate] = useState('');

  const [bonusMap, setBonusMap] = useState({});
  const [bonusNoteMap, setBonusNoteMap] = useState({});

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [empTransactions, setEmpTransactions] = useState(null);
  const [transType, setTransType] = useState('goods_taken');
  const [transAmount, setTransAmount] = useState('');
  const [transNote, setTransNote] = useState('');
  const [showTransModal, setShowTransModal] = useState(false);
  const [attendanceSummary, setAttendanceSummary] = useState([]);

  useEffect(() => {
    fetchEmployees();
    fetchTodayAttendance();
  }, []);

  useEffect(() => {
if (activeTab === 'attendance') {
      fetchAttendance();
      fetchAttendanceSummary();
    }    if (activeTab === 'salary') fetchSalaries();
  }, [activeTab, selectedMonth, selectedYear]);

  const fetchEmployees = async () => {
    try {
      const res = await API.get('/hr/employees');
      setEmployees(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchTodayAttendance = async () => {
    try {
      const res = await API.get('/hr/attendance/today');
      setTodayAttendance(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAttendance = async () => {
    setLoading(true);
    try {
      const res = await API.get(`/hr/attendance?month=${selectedMonth}&year=${selectedYear}`);
      setAttendance(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };
  const fetchAttendanceSummary = async () => {
    try {
      const res = await API.get('/hr/attendance/summary');
      setAttendanceSummary(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSalaries = async () => {
    setLoading(true);
    try {
      const res = await API.get(`/hr/salary?month=${selectedMonth}&year=${selectedYear}`);
      setSalaries(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const fetchEmployeeTransactions = async (empId) => {
    try {
      const res = await API.get(`/hr/transactions/${empId}`);
      setEmpTransactions(res.data);
    } catch (err) {
      toast.error('Failed to load transactions');
    }
  };

  const handleAddTransaction = async (e) => {
    e.preventDefault();
    if (!transAmount || parseFloat(transAmount) <= 0) {
      toast.error('Enter valid amount');
      return;
    }
    try {
      await API.post('/hr/transactions', {
        employee_id: selectedEmployee.id,
        type: transType,
        amount: parseFloat(transAmount),
        note: transNote,
        month: selectedMonth,
        year: selectedYear,
      });
      toast.success('Transaction recorded!');
      setTransAmount('');
      setTransNote('');
      fetchEmployeeTransactions(selectedEmployee.id);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to record transaction');
    }
  };

  const handleAddEmployee = async (e) => {
    e.preventDefault();
    try {
      if (editEmployee) {
        await API.put(`/hr/employees/${editEmployee.id}`, {
          name: empName, nic: empNic, phone: empPhone, role: empRole,
          employee_type: empType, base_salary: parseFloat(empSalary) || 0,
          daily_wage: parseFloat(empWage) || 0, is_active: true,
        });
        toast.success('Employee updated!');
      } else {
        await API.post('/hr/employees', {
          name: empName, nic: empNic, phone: empPhone, role: empRole,
          employee_type: empType, base_salary: parseFloat(empSalary) || 0,
          daily_wage: parseFloat(empWage) || 0, join_date: empJoinDate,
        });
        toast.success('Employee added!');
      }
      resetEmpForm();
      fetchEmployees();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save employee');
    }
  };

  const resetEmpForm = () => {
    setShowAddEmployee(false);
    setEditEmployee(null);
    setEmpName(''); setEmpNic(''); setEmpPhone('');
    setEmpRole(''); setEmpType('permanent');
    setEmpSalary(''); setEmpWage(''); setEmpJoinDate('');
  };

  const handleEditEmployee = (emp) => {
    setEditEmployee(emp);
    setEmpName(emp.name); setEmpNic(emp.nic || '');
    setEmpPhone(emp.phone || ''); setEmpRole(emp.role || '');
    setEmpType(emp.employee_type); setEmpSalary(emp.base_salary);
    setEmpWage(emp.daily_wage); setShowAddEmployee(true);
  };

  const handleDeleteEmployee = async (id, name) => {
    if (!window.confirm(`Delete employee "${name}"?`)) return;
    try {
      await API.delete(`/hr/employees/${id}`);
      toast.success('Employee deleted!');
      fetchEmployees();
    } catch (err) {
      toast.error('Failed to delete employee');
    }
  };

  const handleMarkAttendance = async (employeeId, status) => {
    const today = new Date().toISOString().split('T')[0];
    try {
      await API.post('/hr/attendance/mark', { employee_id: employeeId, date: today, status });
      toast.success(`Marked as ${status}!`);
      fetchTodayAttendance();
    } catch (err) {
      toast.error('Failed to mark attendance');
    }
  };

  const handleCalculateSalary = async (employeeId, empName, deductGoods = true, deductAdvance = true) => {
    try {
      await API.post('/hr/salary/calculate', {
        employee_id: employeeId,
        month: selectedMonth,
        year: selectedYear,
        bonus: parseFloat(bonusMap[employeeId] || 0),
        bonus_note: bonusNoteMap[employeeId] || '',
        deduct_goods: deductGoods,
        deduct_advance: deductAdvance,
      });
      toast.success(`Salary calculated for ${empName}!`);
      fetchSalaries();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to calculate salary');
    }
  };

  const handleMarkPaid = async (salaryId, empName) => {
    if (!window.confirm(`Mark salary as paid for ${empName}?`)) return;
    try {
      await API.put(`/hr/salary/${salaryId}/paid`);
      toast.success('Salary marked as paid!');
      fetchSalaries();
    } catch (err) {
      toast.error('Failed to mark as paid');
    }
  };

  const handleWhatsAppPayslip = (salary) => {
    const emp = employees.find(e => e.id === salary.employee_id);
    if (!emp?.phone) { toast.error('Employee has no phone number!'); return; }
    const shop = JSON.parse(localStorage.getItem('user'));
    let message = `${shop?.shop_name}\n`;
    message += `--------------------------------\n`;
    message += `PAYSLIP - ${months[salary.month - 1]} ${salary.year}\n`;
    message += `--------------------------------\n`;
    message += `Employee: ${salary.employee_name}\n`;
    message += `Type: ${salary.employee_type === 'permanent' ? 'Permanent' : 'Temporary'}\n\n`;
    if (salary.employee_type === 'permanent') {
      message += `Base Salary: LKR ${parseFloat(salary.base_salary).toFixed(2)}\n`;
      message += `Absent Days: ${salary.absent_days}\n`;
      message += `Absent Deduction: - LKR ${parseFloat(salary.absent_deduction).toFixed(2)}\n`;
    } else {
      message += `Daily Wage Total: LKR ${parseFloat(salary.base_salary).toFixed(2)}\n`;
    }
    if (parseFloat(salary.goods_deduction) > 0) {
      message += `Goods Deduction: - LKR ${parseFloat(salary.goods_deduction).toFixed(2)}\n`;
    }
    if (parseFloat(salary.advance_deduction) > 0) {
      message += `Advance Deduction: - LKR ${parseFloat(salary.advance_deduction).toFixed(2)}\n`;
    }
    if (parseFloat(salary.bonus) > 0) {
      message += `Bonus: + LKR ${parseFloat(salary.bonus).toFixed(2)}`;
      if (salary.bonus_note) message += ` (${salary.bonus_note})`;
      message += `\n`;
    }
    message += `--------------------------------\n`;
    message += `Net Salary: LKR ${parseFloat(salary.net_salary).toFixed(2)}\n`;
    message += `--------------------------------\n`;
    message += `Thank you for your service!`;
    const cleanPhone = emp.phone.replace(/\s+/g, '').replace(/^0/, '94');
    window.open(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const getStatusColor = (status) => {
    if (status === 'present') return '#16a34a';
    if (status === 'absent') return '#ef4444';
    if (status === 'late') return '#f59e0b';
    return '#888';
  };

  const getStatusBg = (status) => {
    if (status === 'present') return '#d1fae5';
    if (status === 'absent') return '#fee2e2';
    if (status === 'late') return '#fef3c7';
    return '#f0f0f0';
  };

  return (
    <div>
      <Navbar />
      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @media print {
          body * { visibility: hidden; }
          #payslip-print, #payslip-print * { visibility: visible; }
          #payslip-print { position: absolute; left: 0; top: 0; width: 100%; }
          .no-print { display: none; }
          @page { margin: 10mm; }
        }
      `}</style>

      {showAddEmployee && (
        <div style={styles.overlay} onClick={resetEmpForm}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: '1rem' }}>{editEmployee ? 'Edit Employee' : 'Add New Employee'}</h3>
            <form onSubmit={handleAddEmployee}>
              <input style={styles.modalInput} type="text" placeholder="Full Name *" value={empName} onChange={e => setEmpName(e.target.value)} required />
              <input style={styles.modalInput} type="text" placeholder="NIC Number" value={empNic} onChange={e => setEmpNic(e.target.value)} />
              <input style={styles.modalInput} type="text" placeholder="Phone Number" value={empPhone} onChange={e => setEmpPhone(e.target.value)} />
              <input style={styles.modalInput} type="text" placeholder="Role (e.g. Cashier, Manager)" value={empRole} onChange={e => setEmpRole(e.target.value)} />
              <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.75rem' }}>
                <button type="button" onClick={() => setEmpType('permanent')} style={empType === 'permanent' ? styles.typeActive : styles.typeBtn}>👤 Permanent</button>
                <button type="button" onClick={() => setEmpType('temporary')} style={empType === 'temporary' ? styles.typeActive : styles.typeBtn}>⏱️ Temporary</button>
              </div>
              {empType === 'permanent' ? (
                <input style={styles.modalInput} type="number" placeholder="Monthly Salary (LKR)" value={empSalary} onChange={e => setEmpSalary(e.target.value)} />
              ) : (
                <input style={styles.modalInput} type="number" placeholder="Daily Wage (LKR)" value={empWage} onChange={e => setEmpWage(e.target.value)} />
              )}
              {!editEmployee && (
                <input style={styles.modalInput} type="date" placeholder="Join Date" value={empJoinDate} onChange={e => setEmpJoinDate(e.target.value)} />
              )}
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button style={styles.saveBtn} type="submit">{editEmployee ? 'Save Changes' : 'Add Employee'}</button>
                <button style={styles.cancelBtn} type="button" onClick={resetEmpForm}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showTransModal && selectedEmployee && (
        <div style={styles.overlay} onClick={() => setShowTransModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: '1rem' }}>📒 {selectedEmployee.name} — Add Transaction</h3>
            <form onSubmit={handleAddTransaction}>
              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
                <button type="button" onClick={() => setTransType('goods_taken')}
                  style={transType === 'goods_taken' ? styles.typeActive : styles.typeBtn}>
                  🛍️ Goods Taken
                </button>
                <button type="button" onClick={() => setTransType('cash_advance')}
                  style={transType === 'cash_advance' ? styles.typeActive : styles.typeBtn}>
                  💵 Cash Advance
                </button>
                <button type="button" onClick={() => setTransType('repayment')}
                  style={transType === 'repayment' ? { ...styles.typeActive, background: '#16a34a' } : styles.typeBtn}>
                  ✅ Repayment
                </button>
              </div>
              <input style={styles.modalInput} type="number" placeholder="Amount (LKR) *" value={transAmount} onChange={e => setTransAmount(e.target.value)} min="0" required />
              <input style={styles.modalInput} type="text" placeholder="Note (e.g. Rice 5kg, Festival advance)" value={transNote} onChange={e => setTransNote(e.target.value)} />
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button style={styles.saveBtn} type="submit">Record Transaction</button>
                <button style={styles.cancelBtn} type="button" onClick={() => setShowTransModal(false)}>Cancel</button>
              </div>
            </form>
            {empTransactions && (
              <div style={{ marginTop: '1rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px' }}>
                <p style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  Outstanding Balance:
                  <span style={{ color: empTransactions.outstanding_balance > 0 ? '#ef4444' : '#16a34a', marginLeft: '8px' }}>
                    LKR {empTransactions.outstanding_balance.toFixed(2)}
                  </span>
                </p>
                {selectedEmployee.employee_type === 'temporary' && empTransactions.outstanding_balance > 0 && (
                  <p style={{ fontSize: '12px', color: '#ef4444', margin: 0 }}>
                    ⚠️ Temporary employee has outstanding balance! Must clear before leaving.
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div style={styles.container} className="container">
        <div style={styles.header}>
          <h2 style={styles.title}>👥 HR & Payroll</h2>
          <button onClick={() => setShowAddEmployee(true)} style={styles.addBtn}>+ Add Employee</button>
        </div>

        <div style={styles.tabs}>
          {['today', 'employees', 'attendance', 'salary', 'ledger'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={activeTab === tab ? styles.tabActive : styles.tab}>
              {tab === 'today' ? '📅 Today' : tab === 'employees' ? '👥 Employees' : tab === 'attendance' ? '📋 Attendance' : tab === 'salary' ? '💰 Salary' : '📒 Ledger'}
            </button>
          ))}
        </div>

        {activeTab === 'today' && (
          <div>
            <h3 style={styles.sectionTitle}>Today's Attendance — {new Date().toLocaleDateString()}</h3>
            <div style={styles.attendanceGrid}>
              {todayAttendance.map(emp => (
                <div key={emp.id} style={styles.attendanceCard}>
                  <div style={styles.empInfo}>
                    <div style={styles.empAvatar}>{emp.name.charAt(0).toUpperCase()}</div>
                    <div>
                      <p style={styles.empName}>{emp.name}</p>
                      <p style={styles.empRole}>{emp.role || emp.employee_type}</p>
                      {emp.attendance?.check_in_time && emp.status !== 'absent' && (
                        <p style={{ fontSize: '12px', color: '#16a34a', margin: 0 }}>
                          ✅ Checked in: {new Date(emp.attendance.check_in_time).toLocaleTimeString()}
                        </p>
                      )}
                    </div>
                  </div>
                  <div style={styles.statusBadgeWrap}>
                    {emp.status !== 'not_marked' && (
                      <span style={{ ...styles.statusBadge, background: getStatusBg(emp.status), color: getStatusColor(emp.status) }}>
                        {emp.status === 'present' ? '✅ Present' : emp.status === 'late' ? '⏰ Late' : '❌ Absent'}
                      </span>
                    )}
                  </div>
                  <div style={styles.attendanceBtns} className="no-print">
                    <button onClick={() => handleMarkAttendance(emp.id, 'present')}
                      style={{ ...styles.presentBtn, opacity: emp.status === 'present' ? 1 : 0.5, fontWeight: emp.status === 'present' ? 'bold' : 'normal' }}>
                      ✅ Present
                    </button>
                    <button onClick={() => handleMarkAttendance(emp.id, 'late')}
                      style={{ ...styles.lateBtn, opacity: emp.status === 'late' ? 1 : 0.5, fontWeight: emp.status === 'late' ? 'bold' : 'normal' }}>
                      ⏰ Late
                    </button>
                    <button onClick={() => handleMarkAttendance(emp.id, 'absent')}
                      style={{ ...styles.absentBtn, opacity: emp.status === 'absent' ? 1 : 0.5, fontWeight: emp.status === 'absent' ? 'bold' : 'normal' }}>
                      ❌ Absent
                    </button>
                  </div>
                </div>
              ))}
              {todayAttendance.length === 0 && (
                <p style={{ color: '#888', fontSize: '14px' }}>No active employees found. Add employees first!</p>
              )}
            </div>
          </div>
        )}

        {activeTab === 'employees' && (
          <div>
            <h3 style={styles.sectionTitle}>All Employees ({employees.length})</h3>
            <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>NIC</th>
                  <th style={styles.th}>Phone</th>
                  <th style={styles.th}>Role</th>
                  <th style={styles.th}>Type</th>
                  <th style={styles.th}>Salary/Wage</th>
                  <th style={styles.th}>Join Date</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees.length === 0 ? (
                  <tr><td colSpan="9" style={{ ...styles.td, textAlign: 'center', color: '#888' }}>No employees yet</td></tr>
                ) : (
                  employees.map(emp => (
                    <tr key={emp.id}>
                      <td style={styles.td}>{emp.name}</td>
                      <td style={styles.td}>{emp.nic || '-'}</td>
                      <td style={styles.td}>{emp.phone || '-'}</td>
                      <td style={styles.td}>{emp.role || '-'}</td>
                      <td style={styles.td}>
                        <span style={emp.employee_type === 'permanent' ? styles.permBadge : styles.tempBadge}>
                          {emp.employee_type === 'permanent' ? 'Permanent' : 'Temporary'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        {emp.employee_type === 'permanent'
                          ? `LKR ${parseFloat(emp.base_salary).toFixed(2)}/mo`
                          : `LKR ${parseFloat(emp.daily_wage).toFixed(2)}/day`}
                      </td>
                      <td style={styles.td}>{new Date(emp.join_date).toLocaleDateString()}</td>
                      <td style={styles.td}>
                        <span style={emp.is_active ? styles.activeBadge : styles.inactiveBadge}>
                          {emp.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <button onClick={() => handleEditEmployee(emp)} style={styles.editBtn}>Edit</button>
                        <button onClick={() => handleDeleteEmployee(emp.id, emp.name)} style={styles.deleteBtn}>Delete</button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table></div>
          </div>
        )}

        {activeTab === 'attendance' && (
          <div>
            <div style={styles.filterRow}>
              <select style={styles.filterSelect} value={selectedMonth} onChange={e => setSelectedMonth(parseInt(e.target.value))}>
                {months.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
              </select>
              <select style={styles.filterSelect} value={selectedYear} onChange={e => setSelectedYear(parseInt(e.target.value))}>
                {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>

            <h3 style={styles.sectionTitle}>📊 Monthly Attendance Summary — {months[selectedMonth - 1]} {selectedYear}</h3>
            <div className="mobile-scroll-wrapper"><table style={{ ...styles.table, marginBottom: '2rem' }}>
              <thead>
                <tr>
                  <th style={styles.th}>Employee</th>
                  <th style={styles.th}>Present</th>
                  <th style={styles.th}>Absent</th>
                  <th style={styles.th}>Late</th>
                  <th style={styles.th}>Total Marked</th>
                </tr>
              </thead>
              <tbody>
                {attendanceSummary.length === 0 ? (
                  <tr><td colSpan="5" style={{ ...styles.td, textAlign: 'center', color: '#888' }}>No employees found</td></tr>
                ) : (
                  attendanceSummary.map((emp) => (
                    <tr key={emp.id}>
                      <td style={styles.td}>{emp.name}</td>
                      <td style={{ ...styles.td, color: '#16a34a', fontWeight: 'bold' }}>{emp.present_days}</td>
                      <td style={{ ...styles.td, color: '#ef4444', fontWeight: 'bold' }}>{emp.absent_days}</td>
                      <td style={{ ...styles.td, color: '#f59e0b', fontWeight: 'bold' }}>{emp.late_days}</td>
                      <td style={styles.td}>{emp.total_marked_days} days</td>
                    </tr>
                  ))
                )}
            </tbody>
            </table></div>

            <h3 style={styles.sectionTitle}>📅 Daily Attendance Records</h3>
            {loading ? (
              <div style={styles.loaderWrapper}><div style={styles.spinner}></div></div>
            ) : (
              <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Employee</th>
                    <th style={styles.th}>Date</th>
                    <th style={styles.th}>Status</th>
                    <th style={styles.th}>Check-in Time</th>
                    <th style={styles.th}>Note</th>
                  </tr>
                </thead>
                <tbody>
                  {attendance.length === 0 ? (
                    <tr><td colSpan="5" style={{ ...styles.td, textAlign: 'center', color: '#888' }}>No attendance records</td></tr>
                  ) : (
                    attendance.map(a => (
                      <tr key={a.id}>
                        <td style={styles.td}>{a.employee_name}</td>
                        <td style={styles.td}>{new Date(a.date).toLocaleDateString()}</td>
                        <td style={styles.td}>
                          <span style={{ ...styles.statusBadge, background: getStatusBg(a.status), color: getStatusColor(a.status) }}>
                            {a.status.charAt(0).toUpperCase() + a.status.slice(1)}
                          </span>
                        </td>
                        <td style={styles.td}>
                          {a.check_in_time ? new Date(a.check_in_time).toLocaleTimeString() : '-'}
                        </td>
                        <td style={styles.td}>{a.note || '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table></div>
            )}
          </div>
        )}

        {activeTab === 'salary' && (
          <div>
            <div style={styles.filterRow}>
              <select style={styles.filterSelect} value={selectedMonth} onChange={e => setSelectedMonth(parseInt(e.target.value))}>
                {months.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
              </select>
              <select style={styles.filterSelect} value={selectedYear} onChange={e => setSelectedYear(parseInt(e.target.value))}>
                {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <h3 style={styles.sectionTitle}>Calculate & Pay Salaries</h3>
            <div style={styles.salaryGrid}>
              {employees.filter(e => e.is_active).map(emp => {
                const salary = salaries.find(s => s.employee_id === emp.id);
                return (
                  <div key={emp.id} style={styles.salaryCard}>
                    <div style={styles.salaryHeader}>
                      <div style={styles.empAvatar}>{emp.name.charAt(0).toUpperCase()}</div>
                      <div>
                        <p style={styles.empName}>{emp.name}</p>
                        <p style={styles.empRole}>{emp.role || emp.employee_type}</p>
                      </div>
                      {salary?.is_paid && <span style={styles.paidBadge}>✅ Paid</span>}
                    </div>
                    <div style={styles.salaryDetails}>
                      {salary ? (
                        <>
                          <div style={styles.salaryRow}>
                            <span>Base Salary:</span>
                            <span>LKR {parseFloat(salary.base_salary).toFixed(2)}</span>
                          </div>
                          {emp.employee_type === 'permanent' && (
                            <div style={styles.salaryRow}>
                              <span style={{ color: '#ef4444' }}>Absent Deduction ({salary.absent_days} days):</span>
                              <span style={{ color: '#ef4444' }}>- LKR {parseFloat(salary.absent_deduction).toFixed(2)}</span>
                            </div>
                          )}
                          {parseFloat(salary.goods_deduction) > 0 && (
                            <div style={styles.salaryRow}>
                              <span style={{ color: '#ef4444' }}>Goods Deduction:</span>
                              <span style={{ color: '#ef4444' }}>- LKR {parseFloat(salary.goods_deduction).toFixed(2)}</span>
                            </div>
                          )}
                          {parseFloat(salary.advance_deduction) > 0 && (
                            <div style={styles.salaryRow}>
                              <span style={{ color: '#ef4444' }}>Advance Deduction:</span>
                              <span style={{ color: '#ef4444' }}>- LKR {parseFloat(salary.advance_deduction).toFixed(2)}</span>
                            </div>
                          )}
                          {parseFloat(salary.bonus) > 0 && (
                            <div style={styles.salaryRow}>
                              <span style={{ color: '#16a34a' }}>Bonus ({salary.bonus_note}):</span>
                              <span style={{ color: '#16a34a' }}>+ LKR {parseFloat(salary.bonus).toFixed(2)}</span>
                            </div>
                          )}
                          <div style={{ ...styles.salaryRow, fontWeight: 'bold', fontSize: '16px', borderTop: '1px solid #ddd', paddingTop: '8px', marginTop: '4px' }}>
                            <span>Net Salary:</span>
                            <span style={{ color: '#4f46e5' }}>LKR {parseFloat(salary.net_salary).toFixed(2)}</span>
                          </div>
                        </>
                      ) : (
                        <p style={{ color: '#888', fontSize: '13px' }}>Not calculated yet</p>
                      )}
                    </div>
                    <div style={styles.bonusRow}>
                      <input style={styles.bonusInput} type="number" placeholder="Bonus (LKR)"
                        value={bonusMap[emp.id] || ''} onChange={e => setBonusMap({ ...bonusMap, [emp.id]: e.target.value })} />
                      <input style={styles.bonusInput} type="text" placeholder="Bonus note"
                        value={bonusNoteMap[emp.id] || ''} onChange={e => setBonusNoteMap({ ...bonusNoteMap, [emp.id]: e.target.value })} />
                    </div>
                    <div style={styles.salaryBtns}>
                      <button onClick={() => handleCalculateSalary(emp.id, emp.name, true, true)} style={styles.calcBtn}>
                        🧮 Calculate
                      </button>
                      {salary && !salary.is_paid && (
                        <button onClick={() => handleMarkPaid(salary.id, emp.name)} style={styles.payBtn}>
                          💵 Mark Paid
                        </button>
                      )}
                      {salary && (
                        <button onClick={() => handleWhatsAppPayslip(salary)} style={styles.whatsappBtn}>
                          💬 Payslip
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {activeTab === 'ledger' && (
          <div>
            <h3 style={styles.sectionTitle}>📒 Employee Ledger — Goods & Cash Advances</h3>
            <div style={styles.ledgerGrid}>
              {employees.filter(e => e.is_active).map(emp => (
                <div key={emp.id} style={styles.ledgerCard}>
                  <div style={styles.salaryHeader}>
                    <div style={styles.empAvatar}>{emp.name.charAt(0).toUpperCase()}</div>
                    <div>
                      <p style={styles.empName}>{emp.name}</p>
                      <p style={styles.empRole}>{emp.role || emp.employee_type}</p>
                    </div>
                   <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button
                        onClick={() => {
                          window.location.href = '/invoices/create?type=employee&employee_id=' + emp.id + '&employee_name=' + encodeURIComponent(emp.name);
                        }}
                        style={styles.newInvoiceBtn}
                      >
                        🧾 New Invoice
                      </button>
                      <button
                        onClick={() => {
                          setSelectedEmployee(emp);
                          setShowTransModal(true);
                          fetchEmployeeTransactions(emp.id);
                        }}
                        style={styles.addTransBtn}
                      >
                        + Add
                      </button>
                    </div>
                  </div>
                  {empTransactions && selectedEmployee?.id === emp.id && (
                    <div style={styles.transactionSummary}>
                      <div style={styles.salaryRow}>
                        <span style={{ color: '#ef4444' }}>Total Debit:</span>
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>LKR {empTransactions.total_debit.toFixed(2)}</span>
                      </div>
                      <div style={styles.salaryRow}>
                        <span style={{ color: '#16a34a' }}>Total Repaid:</span>
                        <span style={{ color: '#16a34a', fontWeight: 'bold' }}>LKR {empTransactions.total_repaid.toFixed(2)}</span>
                      </div>
                      <div style={{ ...styles.salaryRow, fontWeight: 'bold', borderTop: '1px solid #ddd', paddingTop: '6px', marginTop: '4px' }}>
                        <span>Outstanding Balance:</span>
                        <span style={{ color: empTransactions.outstanding_balance > 0 ? '#ef4444' : '#16a34a' }}>
                          LKR {empTransactions.outstanding_balance.toFixed(2)}
                        </span>
                      </div>
                      <div style={{ marginTop: '0.75rem', maxHeight: '250px', overflowY: 'auto' }}>
                        {empTransactions.invoices?.length > 0 && (
                          <div style={{ marginBottom: '0.75rem' }}>
                            <p style={{ fontSize: '12px', fontWeight: '600', color: '#444', marginBottom: '0.5rem' }}>📋 Invoice Purchases:</p>
                            {empTransactions.invoices.map((inv, i) => (
                              <div key={i} style={styles.transItem}>
                                <div>
                                  <p style={{ fontSize: '12px', fontWeight: '500', margin: 0 }}>
                                    🧾 Invoice #{inv.invoice_number}
                                  </p>
                                  <p style={{ fontSize: '11px', color: '#888', margin: 0 }}>{new Date(inv.created_at).toLocaleDateString()}</p>
                                </div>
                                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#ef4444' }}>
                                  + LKR {parseFloat(inv.total_amount).toFixed(2)}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        {empTransactions.transactions.length > 0 && (
                          <div>
                            <p style={{ fontSize: '12px', fontWeight: '600', color: '#444', marginBottom: '0.5rem' }}>💰 Other Transactions:</p>
                            {empTransactions.transactions.map((t, i) => (
                              <div key={i} style={styles.transItem}>
                                <div>
                                  <p style={{ fontSize: '12px', fontWeight: '500', margin: 0 }}>
                                    {t.type === 'goods_taken' ? '🛍️ Goods' : t.type === 'cash_advance' ? '💵 Cash Advance' : '✅ Repayment'}
                                  </p>
                                  <p style={{ fontSize: '11px', color: '#888', margin: 0 }}>{t.note || '-'} • {new Date(t.created_at).toLocaleDateString()}</p>
                                </div>
                                <span style={{ fontSize: '13px', fontWeight: 'bold', color: t.type === 'repayment' ? '#16a34a' : '#ef4444' }}>
                                  {t.type === 'repayment' ? '-' : '+'} LKR {parseFloat(t.amount).toFixed(2)}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        {empTransactions.invoices?.length === 0 && empTransactions.transactions.length === 0 && (
                          <p style={{ fontSize: '12px', color: '#888', textAlign: 'center' }}>No transactions yet</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  title: { fontSize: '24px', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tabs: { display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' },
  tab: { padding: '10px 20px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tabActive: { padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  sectionTitle: { fontSize: '18px', marginBottom: '1rem' },
  filterRow: { display: 'flex', gap: '1rem', marginBottom: '1rem' },
  filterSelect: { padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' },
  attendanceGrid: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  attendanceCard: { background: '#fff', borderRadius: '12px', padding: '1rem 1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' },
  empInfo: { display: 'flex', alignItems: 'center', gap: '1rem', flex: 2, minWidth: '200px' },
  empAvatar: { width: '44px', height: '44px', borderRadius: '50%', background: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '18px', color: '#4f46e5', flexShrink: 0 },
  empName: { fontWeight: '500', fontSize: '15px', margin: '0 0 2px' },
  empRole: { fontSize: '12px', color: '#888', margin: 0 },
  statusBadgeWrap: { minWidth: '80px' },
  statusBadge: { padding: '4px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '500' },
  attendanceBtns: { display: 'flex', gap: '0.5rem', flexWrap: 'wrap' },
  presentBtn: { padding: '6px 12px', background: '#d1fae5', color: '#065f46', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  lateBtn: { padding: '6px 12px', background: '#fef3c7', color: '#92400e', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  absentBtn: { padding: '6px 12px', background: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  th: { padding: '12px 16px', background: '#4f46e5', color: '#fff', textAlign: 'left', fontSize: '13px', whiteSpace: 'nowrap' },
  td: { padding: '10px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '13px' },
  permBadge: { padding: '3px 8px', background: '#e0e7ff', color: '#4f46e5', borderRadius: '99px', fontSize: '12px' },
  tempBadge: { padding: '3px 8px', background: '#fef3c7', color: '#92400e', borderRadius: '99px', fontSize: '12px' },
  activeBadge: { padding: '3px 8px', background: '#d1fae5', color: '#065f46', borderRadius: '99px', fontSize: '12px' },
  inactiveBadge: { padding: '3px 8px', background: '#fee2e2', color: '#991b1b', borderRadius: '99px', fontSize: '12px' },
  editBtn: { padding: '4px 10px', background: '#e0e7ff', color: '#4f46e5', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', marginRight: '4px' },
  deleteBtn: { padding: '4px 10px', background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: '#fff', borderRadius: '12px', padding: '2rem', width: '100%', maxWidth: '450px', boxShadow: '0 4px 24px rgba(0,0,0,0.15)', maxHeight: '90vh', overflowY: 'auto' },
  modalInput: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', marginBottom: '0.75rem', boxSizing: 'border-box' },
  typeBtn: { flex: 1, padding: '8px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  typeActive: { flex: 1, padding: '8px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  saveBtn: { flex: 1, padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  cancelBtn: { flex: 1, padding: '10px', background: '#fff', color: '#4f46e5', border: '1px solid #4f46e5', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  salaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem' },
  salaryCard: { background: '#fff', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  salaryHeader: { display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' },
  salaryDetails: { background: '#f9f9f9', borderRadius: '8px', padding: '1rem', marginBottom: '1rem' },
  salaryRow: { display: 'flex', justifyContent: 'space-between', fontSize: '13px', padding: '4px 0' },
  bonusRow: { display: 'flex', gap: '0.5rem', marginBottom: '1rem' },
  bonusInput: { flex: 1, padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px' },
  salaryBtns: { display: 'flex', gap: '0.5rem', flexWrap: 'wrap' },
  calcBtn: { flex: 1, padding: '8px', background: '#e0e7ff', color: '#4f46e5', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  payBtn: { flex: 1, padding: '8px', background: '#d1fae5', color: '#065f46', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  whatsappBtn: { flex: 1, padding: '8px', background: '#25d366', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  paidBadge: { marginLeft: 'auto', padding: '4px 10px', background: '#d1fae5', color: '#065f46', borderRadius: '99px', fontSize: '12px' },
  loaderWrapper: { display: 'flex', justifyContent: 'center', padding: '4rem' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  ledgerGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem' },
  ledgerCard: { background: '#fff', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  addTransBtn: { marginLeft: 'auto', padding: '6px 14px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  newInvoiceBtn: { padding: '6px 12px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' },
  transactionSummary: { marginTop: '1rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px' },
  transItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #f0f0f0' },
};

export default HR;